export default __webpack_public_path__ + "static/media/IraLippkeStudios_Lina_Shteyn_BarDivEng-044.2afec474.jpg";